import {Component, Input, OnInit, OnDestroy, ViewChild, TemplateRef, ViewContainerRef, ChangeDetectorRef, OnChanges, SimpleChanges} from '@angular/core';
import {Globals} from '../../../../globals';
import {StaticDataService} from '../../../../services/static-data.service';
import {DataPatientCaseWorkItemToothModel} from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import {
    DataPatientCaseWorkItemFormToothModel
} from '../../../../models/teeth/data-patient-case-work-item-form-tooth.model';
import {
    PatientCaseEndoFinalReportDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-data.model';
import {FinalReportService} from '../../../../services/final-report.service';
import { FinalReportInfoDto} from '../../../../models/accountsReceivable/data-patient-case.model';
import {ToothService} from '../../../../services/tooth.service';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {DataPatientCaseWorkItemModel} from '../../../../models/accountsReceivable/data-patient-case-work-item.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {DoctorsService} from '../../../../services/doctors.service';
import {DoctorSummaryModel} from '../../../../models/doctors/doctor-summary.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {
    PatientCaseEndoFinalReportRestorRecomdDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-restor-recomd-data.model';
import {ReportConfigurationModel} from '../../../../models/configuration/report-configuration.model';
import {
    PatientCaseEndoFinalReportReferrRepDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-referr-rep-data.model';
import {UiService} from '../../../../services/ui.service';
import {NotesService} from '../../../../services/notes.service';
import {TdoNoteQueryModel} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {FinalReportRecallEnum} from '../../../../models/enum/final-report-recall.enum';
import {
    TdoNoteAssociatedObject,
    TdoNoteSaveModel
} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {MessagingService} from '../../../../services/messaging.service';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {NoteTypeEnum} from '../../../../models/enum/note-type.enum';
import {NoteCategoryEnum} from '../../../../models/enum/note-category.enum';
import {PatientService} from '../../../patient/patient.service';
import {dataPatient} from '../../../ar/_models/ar.models';

import {CommMethodEnum} from '../../../../models/enum/comm-method.enum';
import {NoteDataModel} from '../../../../models/notes/note-data.model';
import {Constants} from '../../../../constants';
import {DoctorTypeEnum} from '../../../../models/enum/doctor-type.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { TreatmentPlanningService } from 'src/app/modules/treatment-planning/treatment-planning.service';
import {DoctorQueryOptionsModel} from '../../../../models/doctors/doctor-query-options.model';
import { Subscription, firstValueFrom, fromEvent, of } from 'rxjs';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { catchError, filter, take } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditEnumDialogComponent } from 'src/app/dialog/edit-enum-dialog/edit-enum-dialog.component';

@Component({
  standalone: false,
    selector: 'app-final-report',
    templateUrl: './final-report.component.html',
    styleUrls: ['./final-report.component.scss']
})
export class FinalReportComponent implements OnInit, OnDestroy, OnChanges {
    @Input() currentCaseId: string;
    @Input() caseWorkItemFormsId: string;
    @ViewChild('enumOptionsMenu') enumOptionsMenu: TemplateRef<any>;

    isLoading = true;
    validValueItems: EnumValidValueItemModel[];
    isContextOpen: boolean = false;
    private overlayRef: OverlayRef | null;
    private contextSub: Subscription;
    noteModel = new TdoNoteSaveModel();
    noteFind = new TdoNoteQueryModel();

    patientCaseModel: FinalReportInfoDto;
    caseTooth: DataPatientCaseWorkItemToothModel;
    caseTeeth: DataPatientCaseWorkItemToothModel[];
    caseFormTeeth: DataPatientCaseWorkItemFormToothModel[];
    workItem: DataPatientCaseWorkItemModel;

    finalReportModel: PatientCaseEndoFinalReportDataModel;
    reports: ReportConfigurationModel[] = [];

    cfgTeeth: ToothConfigurationModel[];
    toothName: string = '';

    statusEnums: EnumValidValueItemModel[] = [];
    prognosisEnums: EnumValidValueItemModel[] = [];
    recallEnums: EnumValidValueItemModel[] = [];
    medicalSpecialtyEnums: EnumValidValueItemModel[] = [];
    caseTypeEnums: EnumValidValueItemModel[] = [];
    restorationMethodEnums: EnumValidValueItemModel[] = [];
    treatmentSessionsEnums: EnumValidValueItemModel[] = [];
    caseRatingEnums: EnumValidValueItemModel[] = [];


    doctors: DoctorSummaryModel[];
    gpDoctors: DoctorSummaryModel[];
    nonGpDoctors: DoctorSummaryModel[];
    providerDoctors: DoctorSummaryModel[];

    fromDoctor: DoctorSummaryModel;
    generalDentist: string = '';
    referringDentist: string = '';
    isUserInput: boolean = false;
    patientData: dataPatient;
    referralEmail: string = '';
    referralDoctorContactId: string = '';
    doctorName: string = '';
    SentToLabel: string = '';
    reportDeliveryMethodEmail = '00000537-1000-0000-0000-000000000001';
    finalReportRestorationMethod_Other = '00000233-1000-0000-0000-000000000002';
    dataPatientCaseEndoFinalReport = 'dataPatientCaseEndoFinalReport';
    doctorDisplayPredicate: (data: DoctorSummaryModel) => string;

    restOtherModel: PatientCaseEndoFinalReportRestorRecomdDataModel;
    reportPreviouslySaved: boolean = false;

    // Queuing system properties
    private saveQueueTimeout: any;
    private currentSaveSubscription: Subscription | null = null;
    private saveInFlight = false;
    private pendingSaveModel: PatientCaseEndoFinalReportDataModel | null = null;
    private readonly SAVE_DEBOUNCE_DELAY = 300; // 300ms delay
    
    // Recall tracking
    private previousRecallDate: Date | null = null;
    private originalRecallDate: Date | null = null;
    isNewRecall: boolean = false;
    isLoadingData:boolean = true;

    constructor(private readonly staticDataService: StaticDataService,
                private readonly finalReportService: FinalReportService,
                private readonly patientService: PatientService,
                private readonly toothService: ToothService,
                private readonly doctorService: DoctorsService,
                private readonly uiService: UiService,
                private readonly notesService: NotesService,
                private readonly messagingService: MessagingService,
                private readonly globals: Globals,
                private readonly dialogService: DialogService,
                private readonly treatmentPlanningService: TreatmentPlanningService,
                private readonly overlay: Overlay,
                private readonly viewContainerRef: ViewContainerRef,
                private readonly dialog: MatDialog,
                private readonly cdr: ChangeDetectorRef) {
        this.patientData = new dataPatient();
        this.noteModel.dataNote = new NoteDataModel();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.caseWorkItemFormsId){
            if (changes.caseWorkItemFormsId.currentValue != changes.caseWorkItemFormsId.previousValue){
                this.LoadFinalReport();
            }
        }
    }

    ngOnInit(): void {
        // console.log('FinalReportComponent Init');
        this.doctorDisplayPredicate = (data: DoctorSummaryModel) => 'Dr. ' + data.dataContact.LastName;

        this.currentCaseId = this.globals.currentPatientCaseId;
        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupEnums();
                }
            });
        } else {
            this.setupEnums();
        }


    }

    ngOnDestroy(): void {
        // Clean up queuing system resources
        if (this.saveQueueTimeout) {
            clearTimeout(this.saveQueueTimeout);
            this.saveQueueTimeout = null;
        }
        // Clean up context menu resources
        this.closeContext();
    }

    async setupEnums() {
        this.isLoadingData = true;
        this.statusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportCaseStatus');
        this.prognosisEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportPrognosis');
        this.recallEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
        this.medicalSpecialtyEnums = this.staticDataService.getValidValueItemsByValidValueName('enumMedicalSpecialty');
        this.caseTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseType');
        this.restorationMethodEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRestorationMethod')        
            .filter(item => item.ValidValueItemId !== this.finalReportRestorationMethod_Other)
            .sort((a, b) => {
                if (a.ItemDisplayValue === 'None') return -1; // Bring 'None' to the top
                if (b.ItemDisplayValue === 'None') return 1;  // Push other values down
                return a.ItemOrder - b.ItemOrder;
            });
        this.treatmentSessionsEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTreatmentSessions');
        this.caseRatingEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseRating');

        this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe({
            next: async (teethRes) => {
            this.cfgTeeth = teethRes;

            const queryModel = new DoctorQueryOptionsModel();
            queryModel.isIncludeReferring = true;
            queryModel.isIncludeTdo = false;
            let docRes: any[] = [];
            //let finalReportdocRes: any[] = [];
            try {
                docRes = await firstValueFrom(this.doctorService.getDoctorsSummary(queryModel)) ?? [];
            } catch (e) {
                console.error('Failed to load doctors for final report', e);
            }

                const gpSpecialtyValidValueItemId: string= '00000005-1000-0000-0000-000000000003';

                this.doctors = docRes;
                this.providerDoctors = docRes.filter(p => p.enumDoctorTypeID === DoctorTypeEnum.PROVIDER);
                this.gpDoctors = docRes.filter(p => {
                    if (p.enumDoctorTypeID === DoctorTypeEnum.REFERRALTO || p.enumDoctorTypeID === DoctorTypeEnum.REFERRALBOTH ) {
                        const specEnum = p.dataDoctorSpecialties.find(q =>
                            q.enumMedicalSpecialtyID === gpSpecialtyValidValueItemId);
                        if (specEnum) {
                            return p;
                        }
                    }
                });
                this.nonGpDoctors = docRes.filter(p => {
                    if (p.enumDoctorTypeID === DoctorTypeEnum.REFERRALTO || p.enumDoctorTypeID === DoctorTypeEnum.REFERRALBOTH ) {
                        const specEnum = p.dataDoctorSpecialties.find(q => q.enumMedicalSpecialtyID !== gpSpecialtyValidValueItemId);
                        if (specEnum) {
                            return p;
                        }
                    }
                });

                this.finalReportService.getReports().subscribe({
                    next: (reportsRes) => {
                        this.reports = reportsRes;
                        this.isLoadingData = false;
                        this.cdr.detectChanges();
                    },
                    error: (e) => {
                        console.error('Failed to load reports for final report', e);
                        this.isLoadingData = false;            
                        this.cdr.detectChanges();
                    },
                });

            //this.LoadFinalReport();
            
            },
            error: (e) => {
                console.error('Failed to load teeth for final report', e);
                this.isLoadingData = false;
                this.cdr.detectChanges();
            },
        });

    }

    private LoadFinalReport() {
        this.isLoading = true;
        if (this.isLoadingData) {
            setTimeout(() => {
                this.LoadFinalReport();
            }, 100);
            return;
        }
        
        this.currentCaseId = this.globals.currentPatientCaseId;
        this.finalReportService.getCaseInfo(this.currentCaseId, this.caseWorkItemFormsId).subscribe({
            next: (caseRes) => {
                this.patientCaseModel = caseRes;
                if (this.patientCaseModel) {
                    const cfgTooth = this.cfgTeeth.find(p => p.ToothId === this.patientCaseModel.CaseWorkItemToothId);
                    if (cfgTooth) {
                        this.toothName = cfgTooth.Name;
                    }
                }

                this.finalReportService.getFinalReport(this.caseWorkItemFormsId).subscribe({
                    next: async (reportRes) => {
                        if (reportRes) {
                            const noteQueryModel = new TdoNoteQueryModel();
                            noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
                            noteQueryModel.objectId = reportRes.CaseFinalReportID;
                            noteQueryModel.patientId = this.globals.currentPatientId;
                            noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
                            noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
                            this.notesService.changeNoteQuery(noteQueryModel);

                            this.finalReportModel = reportRes;
                            // Store the initial recall date for comparison
                            if (this.finalReportModel.RecallDate) {
                                this.previousRecallDate = new Date(this.finalReportModel.RecallDate);
                                this.originalRecallDate = new Date(this.finalReportModel.RecallDate);
                            }
                            await this.SetFinalReportNoteAsync(noteQueryModel);
                            this.restOtherModel = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_Other);
                        } else {
                            this.finalReportModel = new PatientCaseEndoFinalReportDataModel();
                            this.finalReportModel.PatientCaseId = this.currentCaseId;
                            this.finalReportModel.caseWorkItemFormsId = this.caseWorkItemFormsId;
                            this.finalReportModel.caseWorkItemID = this.globals.currentPatientCaseWorkItemID;
                            this.isUserInput = true;
                            console.log('LoadFinalReport saveChanges');
                            this.saveChanges();
                        }

                        this.getReferralDoctorInfo();
                        this.noteModel.patientId = this.noteFind.patientId = this.globals.currentPatientId;
                        this.noteModel.categoryEnumIds = [NoteCategoryEnum.FinalReport];
                        this.noteFind.categoryEnumId = NoteCategoryEnum.FinalReport;
                        this.noteModel.typeEnumIds = [NoteTypeEnum.Patient];
                        this.noteFind.typeEnumId = NoteTypeEnum.Patient;

                        this.patientService.getPatient(this.globals.currentPatientId).subscribe(res => {
                            this.patientData = res.ThePatient;
                            this.isLoading = false;
                            this.cdr.detectChanges();
                        });

                        
                    },
                    error: (e) => {
                        console.error('Failed to load final report', e);
                        this.isLoading = false;
                        this.cdr.detectChanges();
                    },
                });
            },
            error: (e) => {
                console.error('Failed to load case info for final report', e);
                this.isLoading = false;
                this.cdr.detectChanges();
            },
        });
    }

    async saveChanges() {
        if (this.isUserInput) {
            if (this.finalReportModel) {
                if (this.finalReportModel.NoteID === null || this.finalReportModel.NoteID === Constants.emptyGuid) {
                    const noteQueryModel = new TdoNoteQueryModel();
                    noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
                    noteQueryModel.objectId = this.finalReportModel.CaseFinalReportID;
                    noteQueryModel.patientId = this.globals.currentPatientId;
                    noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
                    noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
                    this.notesService.changeNoteQuery(noteQueryModel);
                    await this.SetFinalReportNoteAsync(noteQueryModel)
                }
                this.queueExecuteSaving();
               
            }
        }
    }

    /**
     * Queues the executeSaving function to ensure only the last call is processed
     * when multiple calls are made in quick succession
     */
    private queueExecuteSaving(): void {
        console.log('queueExecuteSaving');
        // Clear any existing timeout
        if (this.saveQueueTimeout) {
            clearTimeout(this.saveQueueTimeout);
        }

        // Set a new timeout to execute the save after the debounce delay
        this.saveQueueTimeout = setTimeout(() => {
            this.saveQueueTimeout = null;
            this.executeSaving();
        }, this.SAVE_DEBOUNCE_DELAY);
    }

    executeSaving(model: PatientCaseEndoFinalReportDataModel = this.finalReportModel){
        // One save at a time. Unsubscribing does not stop a request that was already sent,
        // so overlapping saves each inserted the same new rows (TX-7307). A save requested
        // while one is in flight runs once that one finishes, with the ids it returned.
        if (this.saveInFlight) {
            this.pendingSaveModel = model;
            return;
        }
        this.saveInFlight = true;
        // The response is applied to the model that was sent, even if another report
        // was loaded into this component in the meantime.
        this.currentSaveSubscription = this.finalReportService.saveFinalReport(model).subscribe((res) => {
            const isCurrentModel = model === this.finalReportModel;
            const editsQueued = this.pendingSaveModel === model || (isCurrentModel && this.saveQueueTimeout != null);

            if ((model.CaseFinalReportID === null || model.CaseFinalReportID === undefined) && isCurrentModel && !editsQueued) {
                this.finalReportModel = res;
            } else {
                // Keep the local rows (they may have been edited during the save); only take the new ids
                if (model.CaseFinalReportID === null || model.CaseFinalReportID === undefined) {
                    model.CaseFinalReportID = res.CaseFinalReportID;
                }
                this.applySavedRestorRecomdIds(model, res.dataPatientCaseEndoFinalReportRestorRecomds);
                this.applySavedReferralRepIds(model, res.dataPatientCaseEndoFinalReportReferrReps);
            }

            if (!isCurrentModel) {
                this.finishSaving();
                return;
            }
            this.finalReportModel.Note = this.noteModel.dataNote.Note;
            this.isUserInput = false;

            if (!this.reportPreviouslySaved) { 
                const noteQueryModel = new TdoNoteQueryModel();
                noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
                noteQueryModel.objectId =   this.finalReportModel.CaseFinalReportID ;
                noteQueryModel.patientId = this.globals.currentPatientId;
                noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
                noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
                this.notesService.changeNoteQuery(noteQueryModel);
                this.reportPreviouslySaved = true;
            }
            
            // Update the previous recall date after successful save
            if (this.finalReportModel.RecallDate) {
                this.previousRecallDate = new Date(this.finalReportModel.RecallDate);
            }
            
            this.finishSaving();
        }, (error) => {
            console.error('Error saving final report:', error);
            this.finishSaving();
        });
    }

    private finishSaving(): void {
        this.currentSaveSubscription = null;
        this.saveInFlight = false;
        const pending = this.pendingSaveModel;
        if (pending) {
            this.pendingSaveModel = null;
            this.executeSaving(pending);
        }
    }

    /**
     * Copies the ids the server gave newly ticked recommendations onto the local rows, so the
     * next save updates them instead of inserting them again. The local list is kept as is,
     * because the user may have ticked or unticked items while the save was in flight.
     */
    private applySavedRestorRecomdIds(model: PatientCaseEndoFinalReportDataModel, saved: PatientCaseEndoFinalReportRestorRecomdDataModel[]): void {
        if (!saved || !model.dataPatientCaseEndoFinalReportRestorRecomds) {
            return;
        }
        for (const row of saved) {
            const local = model.dataPatientCaseEndoFinalReportRestorRecomds.find(p =>
                p.enumFinalReportRestorationMethodID === row.enumFinalReportRestorationMethodID &&
                this.isUnsavedId(p.CaseFinalReportRestorRecomendID));
            if (local) {
                local.CaseFinalReportRestorRecomendID = row.CaseFinalReportRestorRecomendID;
            }
        }
    }

    /** Same as applySavedRestorRecomdIds, for referral reports (one per report). */
    private applySavedReferralRepIds(model: PatientCaseEndoFinalReportDataModel, saved: PatientCaseEndoFinalReportReferrRepDataModel[]): void {
        if (!saved || !model.dataPatientCaseEndoFinalReportReferrReps) {
            return;
        }
        for (const row of saved) {
            const local = model.dataPatientCaseEndoFinalReportReferrReps.find(p =>
                p.ReportID === row.ReportID && this.isUnsavedId(p.CaseEndoFinalReportRefRepID));
            if (local) {
                local.CaseEndoFinalReportRefRepID = row.CaseEndoFinalReportRefRepID;
            }
        }
    }

    private isUnsavedId(id: string): boolean {
        return !id || id === Constants.emptyGuid;
    }

    savePatientDNETA() {
        if (this.isUserInput) {
            this.patientService.UpdatePatientDNETA(this.patientData).subscribe((res) => {
                this.patientData = res;
            });
        }
    }

    onCancelClick() {

    }

    onOkClick() {

    }

    getEnumValue(enums: EnumValidValueItemModel[], id: string) {
        if (enums && enums.length > 0 && id) {
            const enu = enums.find(p => p.ValidValueItemId === id);
            if (enu) {
                return enu;
            }
        }
    }

    getDoctor(doctors: DoctorSummaryModel[], id: string) {
        if (doctors && id) {
            const doctor = doctors.find(p => p.DoctorId === id);
            if (doctor) {
                return doctor;
            }
        }
    }

    isRestorationChecked(rec: EnumValidValueItemModel) {
        const resIds = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.map(p => p.enumFinalReportRestorationMethodID);
        return resIds.includes(rec.ValidValueItemId);
    }

    onRestorationChange(event: MatCheckboxChange, rec: EnumValidValueItemModel) {
        this.isUserInput = true;

        const rest = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === rec.ValidValueItemId);

        if (rest) {
            // remove
            const idx = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.findIndex(p => p.enumFinalReportRestorationMethodID === rec.ValidValueItemId);
            if (idx > -1) {
                this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.splice(idx, 1);
            }
        } else {
            // add
            const model = new PatientCaseEndoFinalReportRestorRecomdDataModel();
            model.enumFinalReportRestorationMethodID = rec.ValidValueItemId;
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.push(model);
        }

        console.log('onRestorationChange saveChanges');
        this.saveChanges();
    }

    isRestContainsOther() {
        const resIds = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.map(p => p.enumFinalReportRestorationMethodID);
        return resIds.includes(this.finalReportRestorationMethod_Other);
    }

    onRestOtherChange(event: MatCheckboxChange) {
        this.isUserInput = true;
        // Always drain any existing "Other" (None-GUID) entries first so toggling never
        // stacks duplicates that would show up repeatedly and block deselection (TX-6781).
        this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds =
            this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds
                .filter(p => p.enumFinalReportRestorationMethodID !== this.finalReportRestorationMethod_Other);
        if (event.checked) {
            const model = new PatientCaseEndoFinalReportRestorRecomdDataModel();
            model.enumFinalReportRestorationMethodID = this.finalReportRestorationMethod_Other;
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.push(model);
            this.restOtherModel = model;
            console.log('onRestOtherChange saveChanges');
            this.saveChanges();
        } 
        else {
            this.restOtherModel = null;
        }
    }

    onOtherInputFinished(event: any) {
        this.isUserInput = true;
        console.log('onOtherInputFinished', event);
        const model = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_Other);
        if (model) {
            model.OtherInText = event;
        }

        if (this.restOtherModel) {
            this.restOtherModel.OtherInText = event;
            console.log('onOtherInputFinished 1 saveChanges');
            this.saveChanges();
        }
        else {
            const model = new PatientCaseEndoFinalReportRestorRecomdDataModel();
            model.enumFinalReportRestorationMethodID = this.finalReportRestorationMethod_Other;
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            model.OtherInText = event;
            this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.push(model);
            this.restOtherModel = model;
            console.log('onOtherInputFinished 2 saveChanges');
            this.saveChanges();
        }
    }

    onClearRest() {
        this.isUserInput = true;
        this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds = [];
        console.log('onClearRest saveChanges');
        this.saveChanges();
    }

    onClearReferralReports() {
        this.isUserInput = true;
        this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps = [];
        console.log('onClearReferralReports saveChanges');
        this.saveChanges();
    }

    getOther() {
        const model = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_Other);
        if (model) {
            return model;
        } else {
            return null;
        }
    }

    onReportsChange(event: MatCheckboxChange, report: ReportConfigurationModel) {
        this.isUserInput = true;
        const idx = this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.findIndex(p => p.ReportID === report.ReportID);
        if (idx > -1) {
            this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.splice(idx, 1);
        } else {
            // Add
            const model = new PatientCaseEndoFinalReportReferrRepDataModel();
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            model.ReportID = report.ReportID;
            model.enumReportDeliveryMethodID = this.reportDeliveryMethodEmail;
            model.SentTo = this.referralDoctorContactId;
            this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.push(model);
        }
        console.log('onReportsChange saveChanges');
        this.saveChanges();
    }

    async getReferralDoctorInfo() {
    // get Referral Doctor Information
        try {
            const doctorinfo = await this.doctorService.getReferringDoctorByCaseId(this.globals.currentPatientCaseId).toPromise();
            if (doctorinfo != null)
            {
                const contact = doctorinfo.dataContact;
                this.doctorName = contact.FirstName + ' ' + contact.MidName + ' ' + contact.LastName;
                const email = doctorinfo.dataContact.dataContactComms.filter(y => y.enumCommMethodID === CommMethodEnum.Email)[0];
                this.referralEmail = (email !== undefined && email !== null) ? email.Address : '';
                this.referralDoctorContactId = doctorinfo.dataContact.ContactId;
                this.SentToLabel = this.referralEmail !== '' ? this.doctorName + '(' + this.referralEmail + ')' : this.doctorName + ' (No email for Doctor)';
                if (this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0) {
                    if (this.referralDoctorContactId !== this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps[0].SentTo) {
                        this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.map(x => x.SentTo = this.referralDoctorContactId);
                        this.isUserInput = true;
                        console.log('getReferralDoctorInfo saveChanges');
                        this.saveChanges();
                    }
                }

            }
            else
            { // if not referral doctor associated with the case, then ask user for Referral Doctor
                const referralDoctor = await this.patientService.getPatientReferringDoctor(this.globals.currentPatientId).toPromise();
                if (referralDoctor && referralDoctor.DoctorId) {
                    const contact = referralDoctor.dataContact;
                    this.doctorName = contact.FirstName + ' ' + contact.MidName + ' ' + contact.LastName;
                    const email = referralDoctor.dataContact.dataContactComms.filter(y => y.enumCommMethodID === CommMethodEnum.Email)[0];
                    this.referralEmail = (email !== undefined && email !== null) ? email.Address : '';

                    this.dialogService.openConfirmDialog(`There is not referral Doctor associated to this case. Do you want to assign ${this.doctorName} - ${this.referralEmail}, as the referring Doctor for case: ${this.toothName}?`, true, false).subscribe((res1) => {
                        if (res1) {
                            this.referralDoctorContactId = referralDoctor.dataContact.ContactId;
                            this.SentToLabel = this.referralEmail !== '' ? this.doctorName + '(' + this.referralEmail + ')' : this.doctorName + ' (No email for Doctor)';
                            if (this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0)
                            {
                                if (this.referralDoctorContactId !== this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps[0].SentTo) {
                                    this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.map(x => x.SentTo = this.referralDoctorContactId);
                                    this.isUserInput = true;
                                    console.log('getReferralDoctorInfo saveChanges');
                                    this.saveChanges();
                                }
                            }

                        }
                        else {
                            this.onClearReferralReports();
                            this.finalReportModel.isReportNeede = false;
                            this.referralDoctorContactId = Constants.emptyGuid;
                            this.referralEmail = null;
                        }
                    });
                }
            }
        } catch (e) {
            console.error(e);
        }
    }





    isRefChecked(report: ReportConfigurationModel) {
        const rep = this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.find(p => p.ReportID === report.ReportID);
        return !!rep;
    }

    setUserInput(event: boolean) {
        this.isUserInput = event;
    }

    onCaseStatusChange(event: EnumValidValueItemModel) {
        if (this.isUserInput) {
            this.finalReportModel.enumFinalReportCaseStatusID = event.ValidValueItemId;
            if (event.ItemDisplayValue === '') {
                this.finalReportModel.CompletedDate = null;
            } 
            else {
                if (!this.finalReportModel.CompletedDate) {
                    this.finalReportModel.CompletedDate = new Date(Date.now());
                }
            }
            this.saveChanges();
        }

    }

    getCompletedDate(): Date | null {
        const value = this.finalReportModel.CompletedDate;
        if (!value) {
            return null;
        }
        return value instanceof Date ? value : new Date(value);
    }

    onCompletedDateChange(event: Date | string | null) {
        this.isUserInput = true;

        if (!event) {
            this.finalReportModel.CompletedDate = null;
        } else if (event instanceof Date) {
            this.finalReportModel.CompletedDate = event;
        } else {
            // HTML date inputs emit "YYYY-MM-DD"; parse as a local date.
            const parsed = new Date(`${event}T00:00:00`);
            this.finalReportModel.CompletedDate = isNaN(parsed.valueOf()) ? null : parsed;
        }

        this.saveChanges();
    }

    onOpenLetters() {
        this.uiService.openLettersWindow();
    }

    FinalReportPrognosisSelected(event: any) {
        if (this.isUserInput) {
            this.finalReportModel.enumFinalReportPrognosisID = event.ValidValueItemId;
            console.log('FinalReportPrognosisSelected saveChanges');
            this.saveChanges();
        }
    }

    onRecallTimeChange(event: any) {
        if (this.isUserInput) {

            this.finalReportModel.enumFinalReportRecallID = event.ValidValueItemId;
            const recallDate = new Date();
            let daysMonthsToAdd = 0;
            let addDays = 1;  // 1 = day , 0 = month
            switch (event.ValidValueItemId) {
            case FinalReportRecallEnum.THREE_DAYS:
                daysMonthsToAdd = 3;
                break;
            case FinalReportRecallEnum.ONE_WEEK:
                daysMonthsToAdd = 7;
                break;
            case FinalReportRecallEnum.TWO_WEEKS:
                daysMonthsToAdd = 14;
                break;
            case FinalReportRecallEnum.THREE_WEEKS:
                daysMonthsToAdd = 21;
                break;
            case FinalReportRecallEnum.SIX_WEEKS:
                daysMonthsToAdd = 42;
                break;
            case FinalReportRecallEnum.ONE_MONTH:
                daysMonthsToAdd = 1;
                addDays = 0;
                break;
            case FinalReportRecallEnum.TWO_MONTHS:
                daysMonthsToAdd = 2;
                addDays = 0;
                break;
            case FinalReportRecallEnum.THREE_MONTHS:
                daysMonthsToAdd = 3;
                addDays = 0;
                break;
            case FinalReportRecallEnum.SIX_MONTHS:
                daysMonthsToAdd = 6;
                addDays = 0;
                break;
            case FinalReportRecallEnum.ONE_YEAR:
                daysMonthsToAdd = 365;
                break;
            case FinalReportRecallEnum.TWO_YEARS:
                daysMonthsToAdd = 365 * 2;
                break;
            case FinalReportRecallEnum.THREE_YEARS:
                daysMonthsToAdd = 365 * 3;
                break;
            case FinalReportRecallEnum.FOUR_YEARS:
                daysMonthsToAdd = 365 * 4;
                break;
            case FinalReportRecallEnum.FIVE_YEARS:
                daysMonthsToAdd = 365 * 5;
                break;
            case FinalReportRecallEnum.SIX_YEARS:
                daysMonthsToAdd = 365 * 6;
                break;
            case FinalReportRecallEnum.SEVEN_YEARS:
                daysMonthsToAdd = 365 * 7;
                break;
            case FinalReportRecallEnum.EIGHT_YEARS:
                daysMonthsToAdd = 365 * 8;
                break;
            case FinalReportRecallEnum.NINE_YEARS:
                daysMonthsToAdd = 365 * 9;
                break;
            case FinalReportRecallEnum.TEN_YEARS:
                daysMonthsToAdd = 365 * 10;
                break;
            case FinalReportRecallEnum.ELEVEN_YEARS:
                daysMonthsToAdd = 365 * 11;
                break;
            case FinalReportRecallEnum.TWELVE_YEARS:
                daysMonthsToAdd = 365 * 12;
                break;
            case FinalReportRecallEnum.THIRTEEN_YEARS:
                daysMonthsToAdd = 365 * 13;
                break;
            case FinalReportRecallEnum.FOURTEEN_YEARS:
                daysMonthsToAdd = 365 * 14;
                break;
            case FinalReportRecallEnum.FIFTEEN_YEARS:
                daysMonthsToAdd = 365 * 15;
                break;
            }

            if (addDays == 1){
                // add day
                recallDate.setDate(recallDate.getDate() + daysMonthsToAdd);
            }
            if (addDays == 0){
                // add month
                recallDate.setMonth(recallDate.getMonth() + daysMonthsToAdd);
            }

            
            // Check if recall date has changed
            this.checkRecallDateChange(recallDate);
            
            this.finalReportModel.RecallDate = recallDate;
            console.log('onRecallTimeChange saveChanges');
            this.saveChanges();
        }
    }

    getDateFromModel(recallDate: string) {
        if (recallDate) {
            const d = new Date(recallDate);
            return d.toDateString();
        } else {
            return '';
        }
    }

    onNoteInputFinished(event: string) {
        if (this.finalReportModel.CaseFinalReportID === null || this.finalReportModel.CaseFinalReportID === undefined) {
            console.log('onNoteInputFinished 1 saveChanges');
            this.saveChanges();
            setTimeout(() => {
                this.onNoteInputFinished(event);
            }, 1000);
        } else {
            this.noteModel.text = event;
            this.noteModel.dataNote.Note = event;
            this.noteModel.dataNote.NoteId = this.finalReportModel.NoteID;
            this.finalReportModel.Note = event;

            const assoc = new TdoNoteAssociatedObject();
            assoc.parentObjectName = this.noteFind.parentObjectName = this.dataPatientCaseEndoFinalReport;
            assoc.objectId = this.noteFind.objectId = this.finalReportModel.CaseFinalReportID;
            this.noteModel.associatedObjects = [assoc];

            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, this.noteModel);
            if (this.finalReportModel.NoteID === null || this.finalReportModel.NoteID === undefined) {
                this.updateSetFinalReportNote(this.noteFind);
            }
        }
    }

    updateSetFinalReportNote(noteFind: TdoNoteQueryModel) {
        this.notesService.getNotes(noteFind).subscribe((res) => {
            if (res) {
                if (res.length > 0) {
                    this.finalReportModel.NoteID = res[0].NoteId;
                    this.noteModel.dataNote = res[0];
                    this.isUserInput = true;
                    console.log('updateSetFinalReportNote saveChanges');
                    this.saveChanges();
                } else {
                    setTimeout(() => {
                        this.updateSetFinalReportNote(noteFind);
                    }, 1000);
                }
            } else {
                setTimeout(() => {
                    this.updateSetFinalReportNote(noteFind);
                }, 1000);
            }
        });
    }

    async SetFinalReportNoteAsync(noteFind: TdoNoteQueryModel): Promise<void> {
        let res: any[] | null = null;
        try {
            res = await firstValueFrom(
                this.notesService.getNotes(noteFind).pipe(
                    catchError((e) => {
                        console.error('Failed to load final report notes', e);
                        return of(null);
                    })
                )
            );
        } catch (e) {
            console.error('Failed to load final report notes', e);
        }
        if (res && res.length > 0) {
            this.finalReportModel.NoteID = res[0].NoteId;
            this.finalReportModel.Note = res[0].Note;
            this.noteModel.dataNote = res[0];
        } else if (res !== null) {
            this.finalReportModel.NoteID = Constants.emptyGuid;
        }
    }


    getReportName(reportId: string) {
        return this.reports?.find(x => x.ReportID === reportId)?.ReportName ?? '';
    }


    displayMessage(type, message) {
        this.uiService.displayMessage(type, message);
        
    }



    async sendFinalReport() {
        this.isLoading = true;
        const caseWorkItemEventDoc = await this.treatmentPlanningService.getSelectedDoctorByCaseWorkItemFormID(this.caseWorkItemFormsId).toPromise();
        if (!caseWorkItemEventDoc?.ProviderDoctorId) {
            this.displayMessage('Warning', 'No doctor was selected from the case view.');
            this.isLoading = false;
            this.cdr.detectChanges();
            return;
        }


        const enterpriseId = localStorage.getItem('TDOEnterpriseId');
        if ((this.referralEmail === null || this.referralEmail === '') && this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0) { // if not referral email, and user is trying to send reports. Create alert
            this.createMessage('Please provide an email for Referral Doctor', 'Error');
            this.isLoading = false;
            this.cdr.detectChanges();
            return;
        }
        this.finalReportModel.caseWorkItemID = this.globals.currentPatientCaseWorkItemID;
        this.finalReportService.sendFinalReport(parseInt(this.globals.LOCID), this.globals.currentPatientId, parseInt(enterpriseId), this.referralEmail, this.referralDoctorContactId, this.finalReportModel, this.isNewRecall).subscribe(() => {
            this.createMessage('Final Report Submitted', 'Success');
            this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH_SELECT_CASE, {parentCaseId: this.globals.currentPatientCaseId});
            // Reset recall tracking after successful submission
            this.resetRecallTracking();
            this.isLoading = false;
            this.cdr.detectChanges();
        }, err => {
            this.createMessage(`Error saving Final Report: ${err.error.ExceptionMessage ?? err.error.Message ?? err.error}`, 'Error');
            this.isLoading = false;
            this.cdr.detectChanges();
        });
    } 

    createMessage(message: string, type: string) {
        this.uiService.displayMessage(type, message);
    }


    finalReportPrognosisSelected(event) {
        this.finalReportModel.enumFinalReportPrognosisID = event.ValidValueItemId;
        console.log('finalReportPrognosisSelected saveChanges');
        this.saveChanges();
    }

    referrToDoctorSelected(event) {
        if (event.isUserInput) {
            this.isUserInput = true;
            this.finalReportModel.RefereToDoctorID = event.value?.DoctorId;
            console.log('referrToDoctorSelected saveChanges');
            this.saveChanges();
        }
    }

    referrToGPDoctorSelected(event) {
        // console.log('referrToGPDoctorSelected', event);
        if (event.isUserInput) {
            this.isUserInput = true;
            this.finalReportModel.RefereToGPDoctorID = event.value?.DoctorId;
            console.log('referrToGPDoctorSelected saveChanges');
            this.saveChanges();
        }
    }


    reportNeededChecked(event) {
        // console.log('reportNeededChecked', event);
        this.isUserInput = true;
        this.finalReportModel.isReportNeede = !event.checked;
        if (event.checked) {
            this.onClearReferralReports();
            return;
        }
        console.log('reportNeededChecked saveChanges');
        this.saveChanges();
    }

    /**
     * Test method to verify the queuing system works correctly
     * This method simulates multiple rapid calls to test the debouncing
     */
    testQueuingSystem(): void {
        // console.log('Testing queuing system...');
        
        // Simulate multiple rapid calls
        this.queueExecuteSaving();
        this.queueExecuteSaving();
        this.queueExecuteSaving();
        this.queueExecuteSaving();
        this.queueExecuteSaving();
        
        // console.log('Queuing system test completed - only the last call should be processed');
    }

    /**
     * Resets the recall tracking after the final report is sent
     * This ensures that subsequent changes don't trigger unnecessary recalls
     */
    private resetRecallTracking(): void {
        this.isNewRecall = false;
        if (this.finalReportModel.RecallDate) {
            this.previousRecallDate = new Date(this.finalReportModel.RecallDate);
            this.originalRecallDate = new Date(this.finalReportModel.RecallDate);
        }
    }

    /**
     * Checks if the recall date has changed and sets the isNewRecall flag accordingly
     * Only compares date components (day, month, year) - ignores time
     * Compares against the original recall date to determine if it's truly a new recall
     * @param newRecallDate The new recall date to compare against
     */
    private checkRecallDateChange(newRecallDate: Date): void {
        if (this.originalRecallDate === null) {
            this.isNewRecall = true;
            return;
        }
        
        // Normalize dates to remove time components for comparison
        const originalDate = new Date(this.originalRecallDate.getFullYear(), this.originalRecallDate.getMonth(), this.originalRecallDate.getDate());
        const newDate = new Date(newRecallDate.getFullYear(), newRecallDate.getMonth(), newRecallDate.getDate());
        
        // Compare against the original date - if it's the same, it's not a new recall
        if (originalDate.getTime() === newDate.getTime()) {
            this.isNewRecall = false;
        } else {
            this.isNewRecall = true;
        }
    }

    /**
     * Handles when the recall date is cleared or set to null
     * This also sets the isNewRecall flag if the date was previously set
     */
    onRecallDateCleared(): void {
        if (this.originalRecallDate !== null) {
            this.isNewRecall = true;
        }
        this.previousRecallDate = null;
        console.log('onRecallDateCleared saveChanges');
        this.saveChanges();
    }

    /**
     * Handles right-click context menu on restoration method checkboxes
     */
    onRightMouseClick(event: MouseEvent, enumValue: any): void {
        if (enumValue === undefined) {
            return;
        }
        if (enumValue === undefined || enumValue[0]?.enumValidValue?.isSystem) {
            event.preventDefault();
            this.createMessage('This list is a system list: can not be edited! (contact support)', 'Info');
            return;
        }
        event.preventDefault();
        this.validValueItems = enumValue;
        this.openContext(event, this.enumOptionsMenu, enumValue);
    }

    /**
     * Opens the context menu at the specified position
     */
    openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
        this.isContextOpen = true;
        this.closeContext();
        const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

        this.contextSub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    /**
     * Closes the context menu
     */
    closeContext(): void {
        this.contextSub !== undefined && this.contextSub.unsubscribe();
        if (this.overlayRef) {
            this.isContextOpen = false;
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    /**
     * Opens the enum editor dialog to edit the restoration methods list
     * Refreshes the restoration methods from the static data service after editing
     */
    onEditList(): void {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.validValueItems;

        this.dialog.open(EditEnumDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
                // Clear current values
                this.validValueItems = [];
                this.restorationMethodEnums = [];
                
                // Force refresh from static data service
                setTimeout(() => {
                    this.restorationMethodEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRestorationMethod');
                    
                    this.restorationMethodEnums = this.restorationMethodEnums.filter(item =>
                        !item.xauditDeleted && item.ValidValueItemId !== this.finalReportRestorationMethod_Other);

                    this.validValueItems = this.restorationMethodEnums;
                    
                    // console.log('Refreshed restoration methods:', this.restorationMethodEnums.length, 'items');
                }, 100);
            }
        });
    }
}
